'use client';

import { useRef } from 'react';
import { MlModal } from '@/components/molecules/ml-modal/ml-modal';
import { OrLeadGenForm } from '@/components/organisms/or-lead-gen-form/or-lead-gen-form';
import {
  EModalVariants,
  IModalRefProps,
} from '@/components/molecules/ml-modal/ml-modal.types';
import { sendGTMClickEvent } from '@/components/helpers/analytics/gtm';
import { THeaderSupportedElements } from '@/components/atoms/at-header/at-header.types';
import { EFormType } from '@/components/organisms/or-lead-gen-form/or-lead-gen-form.types';
import { TSpacing } from '@/lib/contentstack-sdk/types';
import { AtClickable } from '@/components/atoms';
import {
  EClickableSize,
  EClickableVariants,
} from '@/components/atoms/at-clickable/at-clickable.types';

interface ClientWrapperProps {
  formId: string;
  formName: string;
  heading: string;
  headingElement: THeaderSupportedElements;
  headingVariant: THeaderSupportedElements;
  description?: string;
  formType: EFormType;
  isInModal?: boolean;
  topSpacing?: TSpacing;
  bottomSpacing?: TSpacing;
}

export const TmDesignCenterDetailsClient = ({
  formId,
  formName,
  heading,
  headingElement,
  headingVariant,
  description,
  formType,
  isInModal,
  topSpacing,
  bottomSpacing,
}: ClientWrapperProps) => {
  const modalRef = useRef<IModalRefProps | null>(null);

  const handleRequestCallClick = () => {
    sendGTMClickEvent(
      'Request a Call',
      'tm-design-center-detail',
      'form-pop-up',
    );
    modalRef.current?.handleOpen();
  };

  return (
    <>
      <MlModal variant={EModalVariants.LEAD_GEN} ref={modalRef}>
        <OrLeadGenForm
          formId={formId}
          formName={formName}
          heading={heading}
          description={description}
          headingElement={headingElement}
          headingVariant={headingVariant}
          formType={formType}
          isInModal={isInModal}
          topSpacing={topSpacing}
          bottomSpacing={bottomSpacing}
        />
      </MlModal>

      <AtClickable
        onClick={handleRequestCallClick}
        outline
        interactLocation="design studio"
        variant={EClickableVariants.PRIMARY}
        size={EClickableSize.LG}
        className="flex w-full justify-center"
        label="Request a Call"
      />
    </>
  );
};
